var isURL = function (value) { return /(\w{2,}\.\w{2,})/.test(value); };
var isEmail = function (value) {
    return /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/.test(value);
};
var isNumber = function (value) { return /^-?\d*(\.\d+)?$/.test(value); };
var isInteger = function (value) { return /^-?\d*$/.test(value); };
var getIsOverMinFn = function (minValue) { return function (value) {
    return Number.parseFloat(value) >= minValue;
}; };
var getIsUnderMaxFn = function (maxValue) { return function (value) {
    return Number.parseFloat(value) <= maxValue;
}; };
export { isURL, isEmail, isNumber, isInteger, getIsOverMinFn, getIsUnderMaxFn };
